import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScroll";
import { formatMoneda } from "../util/varios";

const CatalogoProductoUpdate = (props) => {
  const op = require("../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtCliente = useRef([]);
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [listaClientes, setListaClientes] = useState([]);
  const [clientesTodos, setClientesTodos] = useState([]);
  let values = {
    idproducto: "",
    codigo: "",
    nombre: "",
    idtipoproducto: "",
    idunidadmedida: "",
    ivaventa: 0.0,
    tipoprecio: "",
    idunidadalterna: "",
    idunidadventa: "",
    valorfactor: 0.0,
    tipofactor: "",
    idmoneda: "",
    valormoneda: 0.0,
    costo: 0.0,
    costoalter: 0.0,
    precio: 0.0,
    precioalter: 0.0,
    utilidad: 0.0,
    utilidadalter: 0.0,
    descripcionuni: "",
    descripcionunialt: "",
    imagen: "",
  };

  const headCells = [
    { label: "CODIGO", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
    { label: "UNIDAD", textAlign: "center" },
    { label: "PRECIO", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);
  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = clientesTodos;
    } else {
      lista = clientesTodos.filter((x) => {
        if (
          x.idproducto.includes(target.value) ||
          x.codigo.toLowerCase().includes(target.value.toLowerCase()) ||
          x.nombre.toLowerCase().includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setListaClientes(lista);
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "seleccionar_productos_update()";
    let orden = "idproducto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setListaClientes(response.data);
            setClientesTodos(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setListaClientes([]);
    setClientesTodos([]);
    values = {
      idproducto: "",
      codigo: "",
      nombre: "",
      idtipoproducto: "",
      idunidadmedida: "",
      ivaventa: 0.0,
      tipoprecio: "",
      idunidadalterna: "",
      idunidadventa: "",
      valorfactor: 0.0,
      tipofactor: "",
      idmoneda: "",
      valormoneda: 0.0,
      costo: 0.0,
      costoalter: 0.0,
      precio: 0.0,
      precioalter: 0.0,
      utilidad: 0.0,
      utilidadalter: 0.0,
      descripcionuni: "",
      descripcionunialt: "",
      imagen: "",
    };
  };

  const seleccionarFila = (item, index) => {
    values = {
      idproducto: item.idproducto,
      codigo: item.codigo,
      nombre: item.nombre,
      idtipoproducto: item.idtipoproducto,
      idunidadmedida: item.idunidadmedida,
      ivaventa: item.ivaventa,
      tipoprecio: item.tipoprecio,
      idunidadalterna: item.idunidadalterna,
      idunidadventa: item.idunidadventa,
      valorfactor: item.valorfactor,
      tipofactor: item.tipofactor,
      idmoneda: item.idmoneda,
      valormoneda: item.valormoneda,
      costo: item.costo,
      costoalter: item.costoalter,
      precio: item.precio,
      precioalter: item.precioalter,
      utilidad: item.utilidad,
      utilidadalter: item.utilidadalter,
      descripcionuni: item.descripcionuni,
      descripcionunialt: item.descripcionunialt,
      imagen: item.imagen,
    };

    for (let i = 0; i < txtCliente.current.length; i++) {
      if (i === index) {
        txtCliente.current[i].style.backgroundColor = "lightskyblue";
      } else {
        if (txtCliente.current[i]) {
          txtCliente.current[i].style.backgroundColor = "white";
        }
      }
    }

    btnAcepta.current.focus();
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarCliente = () => {
    props.onHideAceptaCatalogo(values);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Productos</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer
            container={{
              height: 200,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />

            <TableBody>
              {listaClientes &&
                listaClientes.map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtCliente.current[index] = el)}
                    style={{ backgroundColor: "white" }}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.codigo}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.descripcionuni}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {formatMoneda(
                        item.precio
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarCliente}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoProductoUpdate;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoProductoUpdate.js